import { render, staticRenderFns } from "./OrderCart.vue?vue&type=template&id=32e566d6&scoped=true"
import script from "./OrderCart.vue?vue&type=script&lang=js"
export * from "./OrderCart.vue?vue&type=script&lang=js"
import style0 from "./OrderCart.vue?vue&type=style&index=0&id=32e566d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e566d6",
  null
  
)

export default component.exports